export const iconFontAwesomeChartsDiagramsChartBar = (
	<i className="fa-solid fa-chart-bar"></i>
);
